import {
  ELMA365ApplicationIdentityTypeEnum,
  ELMA365ProcessIdentityTypeEnum,
  ELMA365ToolAction,
} from '../../../../gamma-api';
import { IbIconName } from '../../../components/common/IbIcon';

export const ELMA365_COMPONENT_TYPE_ICON_NAMES: { [key: string]: IbIconName } = {
  [ELMA365ApplicationIdentityTypeEnum.Application]: 'ad-product',
  [ELMA365ProcessIdentityTypeEnum.Process]: 'cycle',
};

export const ELMA365_TOOL_ACTION_ICON_NAMES: { [key: string]: IbIconName } = {
  [ELMA365ToolAction.Search]: 'search',
  [ELMA365ToolAction.Get]: 'view-list',
  [ELMA365ToolAction.Create]: 'add-one',
  [ELMA365ToolAction.Update]: 'edit',
  [ELMA365ToolAction.Upsert]: 'refresh',
  [ELMA365ToolAction.Run]: 'play',
};
